module.exports = function() {
  return new Worker(__webpack_public_path__ + "c577578023ca376a7bd8.worker.js");
};